var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMilitary48Filled = function SvgIconMilitary48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.12 19.58-.58 3.4c-.15.88.2 1.75.92 2.28.72.53 1.66.6 2.46.18L24 23.83l3.08 1.61a2.305 2.305 0 0 0 2.45-.18c.72-.53 1.08-1.4.92-2.28l-.58-3.4 2.48-2.4c.64-.62.87-1.54.6-2.39-.28-.85-1-1.46-1.88-1.59l-3.44-.5-1.54-3.1c-.4-.8-1.2-1.29-2.09-1.29-.89 0-1.69.5-2.09 1.29l-1.54 3.1-3.43.5c-.89.13-1.61.73-1.89 1.59-.28.85-.05 1.77.59 2.39l2.48 2.4ZM24 33.45c.39 0 .78-.08 1.15-.23l9.53-4.1L33.34 26l-9.33 4.01L14.68 26l-1.34 3.12 9.53 4.1c.36.16.75.23 1.14.23H24Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24 36.26-9.33-4.01-1.34 3.12 9.53 4.1c.36.16.75.23 1.14.23.39 0 .78-.08 1.15-.23l9.53-4.1-1.34-3.12-9.33 4.01H24Z",
    fill: "current"
  })));
};
export default SvgIconMilitary48Filled;